import smoothScroll from 'smooth-scroll';
import Loader from './components/_loader';
import showLoader from './global/loader-on-event';
import ready from './components/_ready';
import lazyLoader from './components/_lazy-load';
import alert from './alerts/alert';

ready(() => {
  alert();
  setTimeout(lazyLoader, 0);
  Loader.clear();
  showLoader();
  smoothScroll('a[href*="#"]', {
    header: '.navbar',
  });
});
